import { Link } from "react-router-dom";
import useReveal from "@/hooks/useReveal";
import SmartImage from "@/components/SmartImage";
import { ArrowRight } from "lucide-react";

const FOUNDER_PHOTO = "/founder/archana-founder.jpg";

export default function FounderHomepage() {
  const imgRef = useReveal();
  const copyRef = useReveal();

  return (
    <section
      data-testid="founder-homepage"
      className="py-28 md:py-36 lg:py-44 bg-bone-200/40 border-y border-borderwarm"
    >
      <div className="container-luxury grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        {/* LEFT — portrait */}
        <div ref={imgRef} className="reveal lg:col-span-5">
          <div className="relative aspect-[4/5] overflow-hidden bg-sandstone">
            <SmartImage
              src={FOUNDER_PHOTO}
              alt="Archana Panda — Founder, Auraa Designs"
              monogram="A"
              className="w-full h-full object-cover hover:scale-[1.03] transition-transform duration-[1600ms] ease-out"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-espresso/15 via-transparent to-transparent pointer-events-none" />
            <div className="absolute left-5 bottom-5 text-bone/90 text-[10px] uppercase tracking-[0.32em] mix-blend-difference">
              Founder · Auraa
            </div>
          </div>
        </div>

        {/* RIGHT — copy */}
        <div ref={copyRef} className="reveal reveal-delay-2 lg:col-span-7 lg:pl-4">
          <div className="text-[10px] uppercase tracking-[0.32em] text-oxblood font-medium mb-5">
            The Founder
          </div>

          <h2 className="font-serif text-[36px] md:text-[48px] lg:text-[60px] leading-[1.05] tracking-[-0.02em] text-espresso">
            Archana Panda
          </h2>
          <div className="mt-2 text-[12px] uppercase tracking-[0.28em] text-espresso-soft">
            Founder & Designer · Auraa Designs
          </div>

          <div className="mt-8 space-y-5 max-w-2xl text-[15px] md:text-[16px] leading-[1.8] text-espresso-soft font-light">
            <p>
              Archana is a trained fashion designer who founded Auraa in 2022
              after a career building product and design at some of India's
              largest fashion houses. Her work has been showcased at Lakmé
              Fashion Week and across leading national platforms.
            </p>
            <p>
              Auraa was started from a single conviction — that uniforms, in
              hospitality especially, are the most visible and most
              under-designed surface of a brand. Hotels obsess over
              architecture and service rituals, then leave staff presentation
              to procurement catalogues. Auraa was built to close that gap.
            </p>
            <p className="text-espresso">
              Every Auraa programme is led directly by Archana — from the first
              design conversation to fabric sourcing, prototyping, and
              on-property fit. No accounts, no handovers, no compromises in
              translation.
            </p>
          </div>

          <Link
            to="/about"
            data-testid="founder-read-full-story"
            className="group inline-flex items-center gap-2 mt-10 text-[11px] uppercase tracking-[0.28em] font-medium text-oxblood"
          >
            <span className="border-b border-oxblood pb-1">Read the full story</span>
            <ArrowRight size={13} className="transition-transform duration-500 group-hover:translate-x-1" />
          </Link>
        </div>
      </div>
    </section>
  );
}
